import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useAuth } from '../../context/auth';
import './login.scss';

interface LoginForm {
  email: string
  password: string
}

const ViewLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState<LoginForm>({ email: '', password: '' });
  const { loginWithEmail, user } = useAuth();

  const submit = async () => {
    try {
      await loginWithEmail(formData.email, formData.password);
      navigate('/patients');
    } catch (e: any) {
      throw new Error(e.message);
    }
  };

  useEffect(() => {
    if(user) {
      const redirectTo = location.state?.from?.pathname || '/patients';
      navigate(redirectTo, { replace: true });
    }
  }, [user]);


  return (
    <div className="view_login">
      <Form className="loginbox" onSubmit={(e) => {
        e.preventDefault();
        toast.promise(
          submit(),
          {
            loading: 'Logging In...',
            success: <b>Login Successful!</b>,
            error: <b>Login Failed</b>,
          }
        );
      }}>
        <img src="/img/logo-1.png" className="mb-3" height={90} width={160} />
        <Form.Group className="mb-3 w-100">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter Email"
            onChange={(e) => {
              setFormData({
                email: e.target.value,
                password: formData.password
              });
            }} />
        </Form.Group>

        <Form.Group className="mb-3 w-100">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Password"
            onChange={(e) => {
              setFormData({
                email: formData.email,
                password: e.target.value
              });
            }} />
        </Form.Group>
        <Button variant="primary" type="submit" className="w-100">
          Login
        </Button>
      </Form>
    </div>
  );
};

export default ViewLogin;